import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "../../../environments/environment";
import { Appointment } from "../../engine/models/models";
import { UserType, VideoType } from "../../enum";
import { Utilities } from "../../helpers/utilities";
import { Globals } from "../../services/globals";

@Component({
  templateUrl: "welcome.component.html",
  styleUrls: ["welcome.component.css"]
})
export class WelcomeComponent implements OnInit {
  utilities: Utilities = new Utilities();

  constructor(public globals: Globals, public dialog: MatDialog) { }

  ngOnInit() {
    this.globals.hideHeader = true;
    this.globals.hasBackgroundHeaderImage = false;
    this.globals.backgroundHeaderImage = null;
    this.globals.validateSession();
    this.globals.previousSelectedArea = 0;
    localStorage.setItem('windowHeight', window.innerHeight.toString());
  }

  get showVideo(): boolean {
    if (this.globals.isImpersonating) {
      return false;
    }

    return (
      this.globals.appointment?.tutorialVideos?.length &&
      !this.globals.appointment.tutorialVideos.find(x => x.id === VideoType.Introduction).isWatched
    );
  }

  get loginUser(): string {
    const clientName = this.globals.appointment.clientName;
    const coClientName = this.globals.appointment.coClientName;
    return this.utilities.getToken(this.globals.appointment.loginBy === UserType.CoClient ? coClientName : clientName, 0);
  }

  get hasConsultant(): boolean {
    return !!this.globals.appointment?.showroomConsultant;
  }

  indexChanged(event: Event) { }

  navigate() {
    this.globals.displayRooms = true;
  }

  formatProfileImageUrl(url: string) {
    if (!url) {
      return url;
    }

    if (url.includes("http") || url.includes("assets")) {
      return url;
    }

    return environment.userProfileImage + this.encode(url);
  }

  encode(imageUrl: string): string {
    imageUrl = imageUrl.replace(/\(/g, '%28');
    imageUrl = imageUrl.replace(/\)/g, '%29');
    imageUrl = imageUrl.replace(/ /g, '%20'); // Replaces spaces with %20
    return imageUrl;
  }
}
